import { render, staticRenderFns } from "./company_contracts_datatable.vue?vue&type=template&id=4e5a5608"
import script from "./company_contracts_datatable.vue?vue&type=script&lang=js"
export * from "./company_contracts_datatable.vue?vue&type=script&lang=js"
import style0 from "./company_contracts_datatable.vue?vue&type=style&index=0&id=4e5a5608&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports